import omit from "lodash/omit";
import { isEmpty } from "lodash";

export const replaceStateData = (state, { data }, key) => {
  // eslint-disable-next-line
  state = {};
  const items = data[key];
  if (!data || isEmpty(data)) {
    return state;
  }

  return Object.keys(items).reduce((nextState, id) => {
    // eslint-disable-next-line
    nextState[id] = items[id];

    return nextState;
  }, {});
};

export const mergeState = (state, { data }, key) => {
  const items = data[key];
  if (!data || isEmpty(data)) {
    return state;
  }

  return Object.keys(items).reduce((nextState, id) => {
    // eslint-disable-next-line
    nextState[id] = { ...items[id] };

    return nextState;
  }, {});
};

export const insertToState = (state, id, data) => ({
  ...state,
  [id]: data
});

export const removeFromState = (state, id) => {
  if (state[id]) {
    return omit(state, id);
  }

  return state;
};

export const insertProperty = (state, { dealId, property }) => {
  const newArray = state[dealId].properties;
  newArray.push(property);

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      properties: newArray
    }
  };
};

export const updateAQuote = (state, quoteId, quote) => ({
  ...state,
  quotes: { ...state.quotes, [quoteId]: quote }
});

export const addNewNoteToAQuote = (state, quoteId, quote) => ({
  ...state,
  [quoteId]: { ...state[quoteId], notes: quote.notes }
});

export const updateNoteOnAQuote = (state, quoteId, quote) => ({
  ...state,
  [quoteId]: { ...state[quoteId], notes: quote.notes }
});

export const insertUpdatedFund = (state, { fundId }) => ({
  ...state,
  fund: {
    ...state,
    fund: [...state[fundId]]
  }
});

export const insertCategory = (state, { dealId, category, subCategory }) => {
  const newObj = state[dealId].avps[category];
  newObj[subCategory] = {};

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      avps: {
        ...state[dealId].avps,
        [category]: newObj
      }
    }
  };
};

export const insertAttribute = (
  state,
  { dealId, category, subCategory, reference, description, name, order }
) => {
  const newObj = state[dealId].avps[category][subCategory];
  newObj[name] = {
    reference,
    description,
    order
  };

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      avps: {
        ...state[dealId].avps,
        [category]: {
          ...state[dealId].avps[category],
          [subCategory]: newObj
        }
      }
    }
  };
};

export const insertFundCategory = (
  state,
  { fundId, category, subCategory }
) => {
  const copiedFundInfos = { ...state.fundInfos };
  const currentFundInfo = copiedFundInfos[fundId];
  currentFundInfo.avps[category][subCategory] = {};

  return {
    ...state,
    "fundInfos": copiedFundInfos
  };
};

export const insertFundAttribute = (
  state,
  { fundId, category, subCategory, reference, description, name }
) => {
  const copiedFundInfos = { ...state.fundInfos };
  const dictionary = copiedFundInfos[fundId].avps[category][subCategory];
  dictionary[name] = {
    reference, description
  };

  return {
    ...state,
    "fundInfos": copiedFundInfos
  };
};

export const insertAttributeOnALoan = (
  state,
  { dealId, category, subCategory, reference, description, name }
) => {
  const newObj = state[dealId].loan.avps[category][subCategory];
  newObj[name] = {
    reference,
    description
  };

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      loan: {
        ...state[dealId].loan,
        avps: {
          [category]: {
            ...state[dealId].loan.avps[category],
            [subCategory]: newObj
          }
        }
      }
    }
  };
};

export const insertAttributeOnAdditionalLoan = (
  state,
  {
    dealId,
    category,
    subCategory,
    reference,
    description,
    name,
    supplementalLoanIndex
  }
) => {
  const supplementalLoanModel =
    state[dealId].supplementalLoans[supplementalLoanIndex];

  const avpModel =
    state[dealId].supplementalLoans[supplementalLoanIndex].avps[category][
      subCategory
    ];

  avpModel[name] = {
    reference,
    description
  };

  supplementalLoanModel.avps[category][subCategory] = avpModel;

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      supplementalLoans: [
        ...state[dealId].supplementalLoans,
        ...supplementalLoanModel
      ]
    }
  };
};

export const insertCategoryOnAdditionalLoan = (
  state,
  { dealId, category, subCategory, supplementalLoanIndex }
) => {
  const supplementalLoanModel =
    state[dealId].supplementalLoans[supplementalLoanIndex];

  const avpModel =
    state[dealId].supplementalLoans[supplementalLoanIndex].avps[category];

  avpModel[subCategory] = {};

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      supplementalLoans: [
        ...state[dealId].supplementalLoans,
        ...supplementalLoanModel
      ]
    }
  };
};

export const insertAdditionalLoanToModel = (state, { dealId, model }) => ({
  ...state,
  [dealId]: {
    ...state[dealId],
    supplementalLoans: [...state[dealId].supplementalLoans, model]
  }
});

export const insertCategoryOnALoan = (
  state,
  { dealId, category, subCategory }
) => {
  const newObj = state[dealId].loan.avps[category];
  newObj[subCategory] = {};

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      loan: {
        ...state[dealId].loan,
        avps: {
          ...state[dealId].loan.avps,
          [category]: newObj
        }
      }
    }
  };
};

export const insertAttributeOnAMezzLoan = (
  state,
  { dealId, category, subCategory, reference, description, name }
) => {
  const newObj = state[dealId].mezzLoan.avps[category][subCategory];
  newObj[name] = {
    reference,
    description
  };

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      mezzLoan: {
        ...state[dealId].mezzLoan,
        avps: {
          [category]: {
            ...state[dealId].mezzLoan.avps[category],
            [subCategory]: newObj
          }
        }
      }
    }
  };
};

export const insertCategoryOnAMezzLoan = (
  state,
  { dealId, category, subCategory }
) => {
  const newObj = state[dealId].mezzLoan.avps[category];
  newObj[subCategory] = {};

  return {
    ...state,
    [dealId]: {
      ...state[dealId],
      mezzLoan: {
        ...state[dealId].mezzLoan,
        avps: {
          ...state[dealId].mezzLoan.avps,
          [category]: newObj
        }
      }
    }
  };
};

export const dealChangePrepaymentFieldsCategory = (
  state,
  { dealId, obj, category, subcategory }
) => {
  const deal = state[dealId];

  return {
    ...state,
    [dealId]: {
      ...deal,
      loan: {
        ...deal.loan,
        avps: {
          [category]: {
            ...deal.loan.avps[category],
            [subcategory]: {
              ...obj
            }
          }
        }
      }
    }
  };
};

export const mergeFileToDeal = (state, obj, model, id) => {
  const deal = state[id];

  return {
    ...state,
    [id]: {
      ...deal,
      files: [...deal.files, obj.file]
    }
  };
};

export const mergeFeatureImageToDeal = (state, obj, model, id) => {
  const deal = state[id];
  const { imageSmall, imageMedium, imageLarge } = obj;

  return {
    ...state,
    [id]: {
      ...deal,
      imageSmall,
      imageMedium,
      imageLarge
    }
  };
};
